<p>Sorry, an unexpected error has occurred.</p>
<p>Error code: <code>{{ dynamicDialogConfig.data?.errorCode }}</code></p>
<div class="footer">
  <button pButton (click)="onClickRefresh()">Refresh window</button>
</div>
